import PropTypes from "prop-types";

function Button({ children, type, thisStyle, onClick }) {
  return (
    <button type={type} className={thisStyle} onClick={onClick}>
      {children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  thisStyle: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  type: "button",
  thisStyle: "",
  onClick: () => {},
};

export default Button;
